import React from 'react'

import { Stack } from '@zet/design-system'
import { Button, IntegrationFlowHeader } from '@zet/integration-flow'
import { B36, M16 } from '@zet/integration-flow/components/typography'

import CautionIcon from '../../assets/svg/cautionIcon'

interface NoProductsFoundJFSProps {
  onEditPress: () => void
}

const NoProductsFoundJFS = ({ onEditPress }: NoProductsFoundJFSProps) => {
  return (
    <Stack
      className="flex-1 "
      style={{
        backgroundColor: 'white',
      }}
    >
      <IntegrationFlowHeader />
      <Stack className="items-center justify-center flex-1 px-4">
        <CautionIcon />
        <B36 className="text-center mt-11">{'No cards found'}</B36>
        <M16 className="text-center mt-3 text-[#24262BA6]">
          {
            'You may not qualify for credit cards at the moment. Please re-check and edit your details or try again later.'
          }
        </M16>
      </Stack>
      <Button title="Edit info" onPress={onEditPress} loading={false} />
    </Stack>
  )
}

export default NoProductsFoundJFS
